// extracted by mini-css-extract-plugin
export default {"printcontainer":"PrintRankingList_printcontainer__FG0Wv","table":"PrintRankingList_table__4lbCq","notApplicableMajor":"PrintRankingList_notApplicableMajor__9eN1c"};